import React from 'react'
import { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { setPermissions, unsetPermissions } from "../../../Redux/Actions/permission_action"
import SubMenuOperationsCom from './SubMenuOperationsCom';

function SubMenuCom({ menu_id }) {
    let SERVER_URL = process.env.REACT_APP_API_URL;
    let BASE_URL = process.env.REACT_APP_APP_URL;
    let token = JSON.parse(localStorage.getItem('key'));

    const dispatch = useDispatch()
    const [subMenuList, subSubMenuList] = useState([])
    const [sub_Menu, setSub_Menu] = useState([]);
    useEffect(() => {
        getSubMenu(menu_id)
    }, [menu_id])
    const getSubMenu = (menu_id) => {
        fetch(SERVER_URL + `api/menu/get-sub-menu`, {
            method: 'post',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'authorization': `bearer ${token.value}`
            },
            body: JSON.stringify({
                menu_id: menu_id
            })
        }).then(res => res.json()).then(data => {
            if (data.status == true) {
                subSubMenuList(data.results)
            }
        })
    }
    const HandleSubMenu = (value, checked) => {
        if (checked) {
            dispatch(setPermissions(value, checked))
        } else {
            dispatch(unsetPermissions(value, checked))
        }
    }
    let get_per = useSelector((state) => state)

    return (
        <>
            {
                subMenuList?.map((item, ind) => {
                    return <div key={ind} className="col-md-4">
                        <div className="form-check formcheck1 mt00 mb05">
                            <input checked={get_per?.Permission?.permissions?.includes(item.menu_id?.toString())} className="form-check-input" type="checkbox" value={item.menu_id} onChange={(e) => HandleSubMenu(e.target.value, e.target.checked)} />
                            <label className="form-check-label" htmlFor="employee_leave">
                                {item.menu_name}
                            </label>
                        </div>
                    </div>
                })
            }
            <ul className='timeline_wrp'>
                {
                    subMenuList?.map((item, ind) => (
                        (item.menu_id !== 48 ? (
                            <li key={ind}>
                                <div className="timeline_icon"></div>
                                <div className="timeline_text">
                                    <div className="form-blk">
                                        <div className="form-label formlabel_ttl">{item.menu_name}</div>
                                        <div className="form-input row">
                                            <SubMenuOperationsCom submenu_id={item.menu_id} />                               </div>
                                    </div>
                                </div>
                            </li>
                        ) : '')))
                }
            </ul>
        </>
    )
}

export default SubMenuCom
